import React, { useEffect, createElement } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteLayout } from './components/SiteLayout';
// Pages
import { HomePage } from './pages/HomePage';
import { ServicesPage } from './pages/ServicesPage';
import { ProcessPage } from './pages/ProcessPage';
import { ResultsPage } from './pages/ResultsPage';
import { FAQPage } from './pages/FAQPage';
import { ContactPage } from './pages/ContactPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { PrivacyPage } from './pages/PrivacyPage';
import { TermsPage } from './pages/TermsPage';
const FAVICON_URL = 'https://cdn.magicpatterns.com/uploads/4Z9hCxF9GbFsHJdtqTcfuJ/Captura_de_pantalla_2026-05-21_a_las_16.06.43.png';
export function App() {
  // Set browser tab title and favicon
  useEffect(() => {
    document.title = 'Growthly LLC';
    const setFavicon = (rel: string) => {
      let link = document.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`);
      if (!link) {
        link = document.createElement('link');
        link.rel = rel;
        document.head.appendChild(link);
      }
      link.type = 'image/png';
      link.href = FAVICON_URL;
    };
    setFavicon('icon');
    setFavicon('shortcut icon');
    setFavicon('apple-touch-icon');
  }, []);
  return <Router data-id="element-0" data-mp="5opww5kum4f">
      <div className="min-h-screen bg-black font-sans text-gray-100 selection:bg-white selection:text-black" data-id="element-1" data-mp="680tswt8a8y">
        <SiteLayout data-id="element-2" data-mp="2zm4xcjfp5b1a">
          <Routes data-id="element-3" data-mp="2zmo89g6xiz5t">
            <Route path="/" element={<HomePage data-id="element-5" data-mp="33mf1rrnubte1" />} data-id="element-4" data-mp="2zng1ikd20ksx" />
            <Route path="/servicios" element={<ServicesPage data-id="element-7" data-mp="33myix65o2dr0" />} data-id="element-6" data-mp="33nq4rp9gox43" />
            <Route path="/proceso" element={<ProcessPage data-id="element-9" data-mp="38kqce4lym7xb" />} data-id="element-8" data-mp="38m1fs3bhtdnw" />
            <Route path="/resultados" element={<ResultsPage data-id="element-11" data-mp="3dkl3o99ncziw" />} data-id="element-10" data-mp="38kgmeh0x00rm" />
            <Route path="/faq" element={<FAQPage data-id="element-13" data-mp="3dm5ylzzvikha" />} data-id="element-12" data-mp="3dlw6a5rcw18f" />
            <Route path="/contacto" element={<ContactPage data-id="element-15" data-mp="nwc23tmizxws" />} data-id="element-14" data-mp="3dii6n5a2u64o" />
            <Route path="/checkout" element={<CheckoutPage data-id="element-17" data-mp="nxwv3et6z8sj" />} data-id="element-16" data-mp="nv0ypuwzss67" />
            <Route path="/privacidad" element={<PrivacyPage data-id="element-19" data-mp="st2iyj65mxj9" />} data-id="element-18" data-mp="su427axbqqc2" />
            <Route path="/terminos" element={<TermsPage data-id="element-21" data-mp="35ymodf6r9ya" />} data-id="element-20" data-mp="swglpsiqd8r8" />
          </Routes>
        </SiteLayout>
      </div>
    </Router>;
}